export enum GiftType {
    COINS = 'coins',
    COINS_CUSTOM = 'coins_custom',
    FREESPINS = 'freespins',
}